import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer data-testid="main-footer" className="border-t border-border bg-card mt-24">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="md:col-span-2">
            <h3 className="font-serif text-2xl font-bold mb-4">ProductPulse</h3>
            <p className="text-muted-foreground leading-relaxed mb-6">
              Your trusted source for honest, in-depth consumer product reviews. We test, evaluate, and recommend the best products to help you make informed purchasing decisions.
            </p>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-muted-foreground hover:text-primary smooth-transition">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/reviews" className="text-muted-foreground hover:text-primary smooth-transition">
                  All Reviews
                </Link>
              </li>
              <li>
                <Link to="/categories" className="text-muted-foreground hover:text-primary smooth-transition">
                  Categories
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Categories</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/category/technology" className="text-muted-foreground hover:text-primary smooth-transition">
                  Technology
                </Link>
              </li>
              <li>
                <Link to="/category/home-kitchen" className="text-muted-foreground hover:text-primary smooth-transition">
                  Home & Kitchen
                </Link>
              </li>
              <li>
                <Link to="/category/audio" className="text-muted-foreground hover:text-primary smooth-transition">
                  Audio
                </Link>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-border mt-12 pt-8 text-center text-sm text-muted-foreground">
          <p>&copy; 2026 ProductPulse. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;